/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.cvEtape.ts
 *
 * Messages de la dernière étape de l'inscription : le dépôt du CV.
 * Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-09-24
 */
export const messagesCvEtapeFr: Record<string, string> = {
  'cvEtape.titre': 'Dernière étape : votre CV',
  // 2026-09-28 : quand l'étape « application » suit. Mikael - chef de projet - 2026-09-28
  'cvEtape.titreAvantApplication': 'Votre CV',
  'cvEtape.compteCree': 'Votre compte est créé. Vous êtes inscrit·e.',
  'cvEtape.corps':
    'Déposez votre CV maintenant : c’est lui qui permet aux entreprises de vous proposer des postes, et de vous contacter avant même votre venue. Sans CV, elles ne peuvent rien vous proposer.',
  'cvEtape.visibilite':
    'Par défaut, seules les entreprises dont vous scannez le stand peuvent l’ouvrir. Vous pouvez élargir ou tout fermer à tout moment depuis « Mon profil ».',
  'cvEtape.choisir': 'Déposer mon CV',
  'cvEtape.choisir.aria': 'Choisir le fichier de votre CV',
  'cvEtape.envoi': 'Envoi en cours…',
  'cvEtape.plusTard': 'Continuer sans déposer',
  'cvEtape.depose': 'CV enregistré. Merci.',
  'cvEtape.formats': 'Formats acceptés : {ext}. {mo} Mo au maximum.',
  'cvEtape.erreur.tropLourd': 'Fichier trop lourd : {mo} Mo au maximum.',
  'cvEtape.erreur.format': 'Format non accepté : {ext} seulement.',
  'cvEtape.erreur.mineur':
    'Le dépôt de CV n’est pas ouvert aux personnes mineures sur cet événement.',
  'cvEtape.erreur.envoi': 'Impossible d’enregistrer le CV. Vous pourrez le déposer depuis « Mon profil ».',
};
